import React from "react";
import { Box, VStack, HStack, Text, Button } from "native-base";
import { Loc } from "../../App/Loc";
import AVCancel from "../../components/common/AVCancel";

interface AVConfirmLinkPopupProps {
  isMobile?: boolean;
  dimensions?: { width: number; height: number };
  url?: string;
  handleCancel?: () => void;
}

const AVConfirmLinkPopup: React.FC<AVConfirmLinkPopupProps> = ({
  isMobile = false,
  dimensions = { width: 500, height: 400 },
  url = "",
  handleCancel,
}) => {
  const closePopup = () => {
    handleCancel?.();
  };

  const handleConfirm = () => {
    if (url) window.open(url, "_blank");
    closePopup();
  };

  return (
    <Box
      position="fixed"
      bgColor="rgba(0, 0, 0, 0.1)"
      bottom={0}
      right={0}
      top={0}
      left={0}
      zIndex={99999}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <div
        className={`create_post_popup ${isMobile ? "create_post_popup_mobile" : ""}`}
        style={{
          width: isMobile ? dimensions.width - 15 : "450px",
          height: isMobile ? "400px" : "220px",
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "24px",
        }}
      >
        <VStack width="100%">
          {/* Header */}
          <HStack justifyContent="space-between" alignItems="center" mb="12px">
            <Text fontSize="24px" fontWeight={600}>
              {Loc.currentLang?.myPlan?.confirmation ?? "Confirmation"}
            </Text>

            <AVCancel
              callback={closePopup}
              color={undefined}
              size={undefined}
            />
          </HStack>

          {/* Message */}
          <VStack alignItems="center" mt="20px">
            <Text fontSize="18px" textAlign="center">
              {Loc.currentLang?.menu?.linkOpenConfirmText ??
                "Do you want to open this link?"}
            </Text>

            {url && (
              <Text
                mt="10px"
                color="AVColor.primary"
                textAlign="center"
                noOfLines={2}
                ellipsizeMode="tail"
              >
                {url}
              </Text>
            )}
          </VStack>

          {/* Buttons */}
          <HStack justifyContent="center" space="24px" mt="32px">
            <Button
              width="140px"
              height="40px"
              backgroundColor="AVColor.grey"
              rounded="full"
              onPress={closePopup}
            >
              <Text fontWeight={500} color="white">
                {Loc.currentLang?.menu?.cancel ?? "Cancel"}
              </Text>
            </Button>

            <Button
              width="140px"
              height="40px"
              backgroundColor="AVColor.primary"
              rounded="full"
              onPress={handleConfirm}
            >
              <Text fontWeight={500} color="white">
                {Loc.currentLang?.landingPage?.openApp ?? "Open Link"}
              </Text>
            </Button>
          </HStack>
        </VStack>
      </div>
    </Box>
  );
};

export default React.memo(AVConfirmLinkPopup);
